<div
  class="ebo-toggle"
  [class.ebo-toggle--disabled]="disabled"
  [class.ebo-toggle--children]="style === 1"
>
  <!-- Label & Toggle Container -->
  <div class="ebo-toggle__container">
    <div *ngIf="label" class="ebo-toggle__label-group">
      <label
        class="ebo-toggle__label"
        [class.ebo-toggle--children--title]="style === 1"
        [class.ebo-toggle__label--with-subtitle]="subtitle"
      >
        {{ label }}
      </label>
      <span *ngIf="subtitle" class="ebo-toggle__subtitle">{{ subtitle }}</span>
    </div>

    <mat-slide-toggle
      [checked]="control?.value"
      (change)="onToggleChange($event)"
      [disabled]="disabled"
      color="primary"
      class="ebo-toggle__switch"
    >
    </mat-slide-toggle>
  </div>

  <!-- Hint Text -->
  <span *ngIf="hint" class="ebo-toggle__hint">
    {{ hint }}
  </span>
</div>
